import { isDefined, MINUTE } from '@enterprise/core';

import { getEnvVar } from '@/utilities/get-env-var';

const rawHeartbeatThreshold = getEnvVar('VITE_APP_SESSION_HEARTBEAT_THRESHOLD_MINUTES');
const parsedHeartbeatThreshold = isDefined(rawHeartbeatThreshold)
  ? Number.parseInt(rawHeartbeatThreshold, 10)
  : Number.NaN;

/**
 * The heartbeat threshold in milliseconds, derived from `VITE_APP_SESSION_HEARTBEAT_THRESHOLD_MINUTES`.
 * Falls back to 30 minutes if the env var is absent, non-numeric, or not a positive number.
 */
export const heartbeatThresholdMs =
  Number.isFinite(parsedHeartbeatThreshold) && parsedHeartbeatThreshold > 0
    ? parsedHeartbeatThreshold * MINUTE
    : 30 * MINUTE;
